import React from 'react';
import {formatDuration} from 'components/dashboard/coaching-effectiveness/common';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

export default class ManagerCoachingTimeReceived extends React.PureComponent {
  render() {
    const {coachingTimeFromProvider, coachingTimeTotal, providerIsCoach} = this.props;
    const total = formatDuration(coachingTimeTotal);
    const provider = formatDuration(coachingTimeFromProvider);
    return (
      <GenericTooltip
        tooltip={tooltipContent(total, provider, providerIsCoach)}
        positionTop
        delay={TOOLTIP_DELAY}>
        <span>{`${total} / ${provider}`}</span>
      </GenericTooltip>
    );
  }

  registerPopoverItem(anchorEl, content) {
    if (this.popoverContainer) {
      this.popoverContainer.registerPopoverItem(anchorEl, content);
    }
  }
}

function tooltipContent(total, provider, providerIsCoach) {
  return (
    <div>
      <p>Total coaching time: {total}</p>
      <p>{`Coaching time by ${providerIsCoach ? 'coach' : 'team manager'}: ${provider}`}</p>
    </div>
  );
}
